import { AuthService } from '@/app/core/services/auth.service';
import { InstructivoService } from '@/app/core/services/instructivo.service';
import { Instructivo } from '@/app/models/interface/instructivo.model';

import { environment } from '@/environments/environment';
import { HttpParams } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * @description Listado de instructivos del panel lateral derecho (drawer).
 * A partir de plan-33/plan-34, el clic en una tarjeta ya no abre un modal
 * propio con el PDF — navega a la pantalla `c-instructivo-visor`
 * (`/capacitaciones/instructivos/:id`), la misma que usa la pantalla
 * "Instructivos" a pantalla completa. Así queda un solo lugar donde se ve
 * un instructivo, sin duplicar la lógica del visor PDF.
 */
@Component({
  selector: 'c-card-instructivo',
  templateUrl: './card-instructivo.component.html',
  styleUrl: './card-instructivo.component.css',
  standalone: false,
})
export class CardInstructivoComponent {
  private readonly instructivoService = inject(InstructivoService);
  private readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  instructivos: Instructivo[] = [];

  async ngOnInit() {
    const usuario = await this.auth.returnUserInfo();

    if (usuario) {
      let params = new HttpParams()
        .set('activo', 'true')
        .set('sortBy', 'asc')
        .set('sortByProperty', 'id');

      const isAdmin =
        usuario.roles?.some((rol) => rol?.rol == 'ADMINISTRADOR') ||
        usuario.superadmin;

      if (!isAdmin) {
        const rolesId = usuario.roles.map((rol) => rol.id);
        const subRolesId = usuario.subRoles.map((subRol) => subRol.id);
        params = params.set('rolId', JSON.stringify(rolesId));
        params = params.set('subRolId', JSON.stringify(subRolesId));
      }

      this.instructivoService.findAll(params).subscribe(
        (data) =>
          (this.instructivos = data.data.map((instructivo) => ({
            ...instructivo,
            thumbnail: environment.images + 'previews/' + instructivo.thumbnail,
            adjunto: environment.images + instructivo.adjunto,
          }))),
      );
    }
  }

  abrir(instructivo: Instructivo) {
    const usuarioInstructivo = instructivo.instructivoUsuarios[0];
    this.router.navigate(['/capacitaciones/instructivos', instructivo.id], {
      queryParams: usuarioInstructivo
        ? { page: usuarioInstructivo.page, percent: usuarioInstructivo.percent }
        : {},
    });
  }
}
